export default "__VITE_ASSET__67a9798e__"